/* CellCut — skrypty motywu */
(function () {
  var NOC = window.NOC || (window.NOC = {});
  var root = NOC.root || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- pieniądze ---------- */
  NOC.money = function (cents) {
    var fmt = NOC.moneyFormat || '{{amount_with_comma_separator}} zł';
    var v = (Number(cents) || 0) / 100;
    function f(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return f(v, 2, ',', '.');
        case 'amount_no_decimals': return f(v, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return f(v, 0, '.', ',');
        case 'amount_with_space_separator': return f(v, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return f(v, 2, ' ', '.');
        default: return f(v, 2, '.', ',');
      }
    });
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function json(res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || d.message || 'Błąd koszyka'); return d; }); }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  }

  /* ---------- koszyk ---------- */
  var drawer, body, foot;
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }

  function render(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><h3>Twój koszyk jest pusty</h3><p>Dodaj produkt, aby przejść dalej.</p><button type="button" class="btn btn--ghost" data-drawer-close>Wróć do zakupów</button></div>';
      foot.hidden = true;
      return;
    }
    var html = '';
    var tip = drawer.getAttribute('data-tip');
    var units = 0;
    cart.items.forEach(function (it) { units += it.quantity; });
    if (tip && units === 1) html += '<div class="drawer__tip">' + esc(tip) + '</div>';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
      var disc = (it.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean).join(', ');
      html += '<div class="ditem" data-key="' + esc(it.key) + '">' +
        '<div class="ditem__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</div>' +
        '<div><div class="ditem__title">' + esc(it.product_title) + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ditem__var">' + esc(it.variant_title) + '</div>' : '') +
        (disc ? '<div class="ditem__disc">' + esc(disc) + '</div>' : '') +
        '<div class="qty"><button type="button" data-qty="-1" aria-label="Zmniejsz ilość">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Zwiększ ilość">+</button></div></div>' +
        '<div><div class="ditem__price">' + NOC.money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<s>' + NOC.money(it.original_line_price) + '</s>' : '') + '</div>' +
        '<button type="button" class="ditem__rm" data-remove>Usuń</button></div></div>';
    });
    body.innerHTML = html;
    var disc = cart.total_discount || 0;
    foot.querySelector('[data-sub]').textContent = NOC.money(cart.original_total_price || cart.items_subtotal_price);
    var dr = foot.querySelector('[data-disc-row]');
    dr.hidden = !disc;
    foot.querySelector('[data-disc]').textContent = '−' + NOC.money(disc);
    foot.querySelector('[data-total]').textContent = NOC.money(cart.total_price);
    foot.hidden = false;
  }

  NOC.refresh = function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (c) { render(c); return c; }); };
  NOC.open = function () {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
    var c = drawer.querySelector('[data-drawer-close]'); if (c) c.focus();
  };
  NOC.close = function () { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };

  /* items: [{id, quantity}] */
  NOC.add = function (items) {
    return post('cart/add.js', { items: items }).then(function () {
      var mode = NOC.afterAdd || 'drawer';
      if (mode === 'checkout') { window.location.href = root + 'checkout'; return; }
      if (mode === 'cart' || !drawer) { window.location.href = root + 'cart'; return; }
      return NOC.refresh().then(NOC.open);
    });
  };

  function change(key, qty) {
    body.style.opacity = '.5';
    return post('cart/change.js', { id: key, quantity: qty }).then(render).catch(function () {}).then(function () { body.style.opacity = ''; });
  }

  function initDrawer() {
    drawer = document.getElementById('noc-drawer');
    if (!drawer) return;
    body = drawer.querySelector('[data-drawer-body]');
    foot = drawer.querySelector('[data-drawer-foot]');
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { NOC.close(); return; }
      var row = e.target.closest('.ditem'); if (!row) return;
      var key = row.getAttribute('data-key');
      var q = parseInt(row.querySelector('.qty span').textContent, 10);
      var b = e.target.closest('[data-qty]');
      if (b) change(key, Math.max(0, q + parseInt(b.getAttribute('data-qty'), 10)));
      if (e.target.closest('[data-remove]')) change(key, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') NOC.close(); });
    document.querySelectorAll('[data-open-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); NOC.refresh().then(NOC.open); });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rv');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- pasek ogłoszeń ---------- */
  function initAnn() {
    document.querySelectorAll('[data-ann]').forEach(function (a) {
      var items = a.querySelectorAll('.ann__item'); if (items.length < 2) return;
      var i = 0, t = (parseInt(a.getAttribute('data-ann'), 10) || 4) * 1000;
      setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, t);
    });
  }

  /* ---------- galeria + lightbox ---------- */
  function initGallery(g) {
    var track = g.querySelector('.gal__track'); if (!track) return;
    var slides = track.querySelectorAll('.gal__slide');
    var thumbs = g.querySelectorAll('.gal__thumb');
    var count = g.querySelector('[data-gal-count]');
    var idx = 0;
    function go(i, smooth) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * idx, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark(i) {
      idx = i;
      if (count) count.textContent = (i + 1);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); if (k === i && t.scrollIntoView) t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2; });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('.gal__arrow--prev'), n = g.querySelector('.gal__arrow--next');
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (n) n.addEventListener('click', function () { go(idx + 1); });

    var lb = g.querySelector('.lb'); if (!lb) return;
    var lbImg = lb.querySelector('img');
    var srcs = Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-zoom'); });
    var li = 0;
    function show(i) { li = (i + srcs.length) % srcs.length; lbImg.src = srcs[li]; }
    function open() { show(idx); lb.classList.add('is-open'); document.body.classList.add('no-scroll'); }
    function close() { lb.classList.remove('is-open'); document.body.classList.remove('no-scroll'); go(li, false); }
    g.querySelectorAll('[data-zoom-open]').forEach(function (b) { b.addEventListener('click', open); });
    lb.querySelector('.lb__close').addEventListener('click', close);
    lb.querySelector('.lb__nav--prev').addEventListener('click', function () { show(li - 1); });
    lb.querySelector('.lb__nav--next').addEventListener('click', function () { show(li + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(li - 1); if (e.key === 'ArrowRight') show(li + 1);
    });
  }

  /* ---------- licznik promocji ---------- */
  function initCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.hidden = true; return; }
    var cells = el.querySelectorAll('[data-cd]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; clearInterval(t); return; }
      var s = Math.floor(d / 1000);
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      cells.forEach(function (c, i) { c.textContent = pad(v[i]); });
    }
    var t = setInterval(tick, 1000); tick(); el.hidden = false;
  }

  /* ---------- buy-box (pakiety, sticky, upsell) ---------- */
  function initBuy(box) {
    var form = box.querySelector('[data-buy-form]'); if (!form) return;
    var cta = form.querySelector('[data-buy-cta]');
    var err = form.querySelector('[data-buy-err]');
    var now = box.querySelectorAll('[data-price-now]'), old = box.querySelectorAll('[data-price-old]'), save = box.querySelectorAll('[data-price-save]'), pct = box.querySelectorAll('[data-price-pct]');
    function set(list, v) { list.forEach(function (e) { e.textContent = v; }); }
    function sel() { return form.querySelector('input[name="pack"]:checked'); }
    function sync() {
      var r = sel(); if (!r) return;
      var p = +r.getAttribute('data-total'), c = +r.getAttribute('data-compare');
      set(now, NOC.money(p));
      set(old, c > p ? NOC.money(c) : '');
      set(save, c > p ? NOC.money(c - p) : '');
      set(pct, c > p ? '-' + Math.round((1 - p / c) * 100) + '%' : '');
      box.querySelectorAll('[data-save-wrap]').forEach(function (w) { w.hidden = !(c > p); });
    }
    form.addEventListener('change', function (e) {
      // wybór koloru: wszystkie pakiety dodają wybrany wariant
      if (e.target.name === 'variant') {
        form.querySelectorAll('input[name="pack"]').forEach(function (p) { p.setAttribute('data-variant', e.target.value); });
        var nm = form.querySelector('[data-vpick-name]'); if (nm) nm.textContent = e.target.getAttribute('data-vpick');
      }
      sync();
    });
    sync();

    function buy() {
      var r = sel(); if (!r) return;
      if (err) err.hidden = true;
      var items = [{ id: +r.getAttribute('data-variant'), quantity: +r.getAttribute('data-qty') }];
      var up = form.querySelector('[data-upsell]:checked');
      if (up && up.getAttribute('data-variant')) items.push({ id: +up.getAttribute('data-variant'), quantity: 1 });
      var btns = box.querySelectorAll('[data-buy-cta],[data-sbar-cta]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      NOC.add(items).catch(function (e) { if (err) { err.textContent = e.message || 'Nie udało się dodać do koszyka.'; err.hidden = false; } })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); buy(); });

    var sbar = box.querySelector('[data-sbar]');
    if (sbar) {
      sbar.querySelector('[data-sbar-cta]').addEventListener('click', buy);
      var footer = document.querySelector('.ftr');
      var upd = function () {
        var b = cta.getBoundingClientRect();
        var f = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var on = b.bottom < 0 && !f;
        sbar.classList.toggle('is-on', on); sbar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      window.addEventListener('scroll', upd, { passive: true }); upd();
    }
  }

  /* ---------- wideo ---------- */
  function initVideos() {
    document.querySelectorAll('.vid').forEach(function (v) {
      var video = v.querySelector('video'); if (!video) return;
      v.addEventListener('click', function () {
        document.querySelectorAll('.vid video').forEach(function (o) { if (o !== video) { o.pause(); o.closest('.vid').classList.remove('is-playing'); } });
        if (video.paused) { video.muted = false; video.play(); v.classList.add('is-playing'); }
        else { video.pause(); v.classList.remove('is-playing'); }
      });
      video.addEventListener('ended', function () { v.classList.remove('is-playing'); });
    });
  }

  /* ---------- przed / po ---------- */
  function initBA() {
    document.querySelectorAll('.ba').forEach(function (ba) {
      var r = ba.querySelector('input'); if (!r) return;
      r.addEventListener('input', function () { ba.style.setProperty('--pos', r.value + '%'); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initReveal();
    initAnn();
    initVideos();
    initBA();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-buybox]').forEach(initBuy);
  });
})();
